import { Fragment } from "react";
import parse from "html-react-parser";
import dynamic from "next/dynamic";
import { dehydrate, QueryClient, useQueries } from '@tanstack/react-query';
import queryConfig from "../../utils/api/queryConfig";

import Error from "../_error";
import { getQueryFn, queryKeyManager } from "../../utils/api/queryFunction";

const SEO = dynamic(() => import("../../components/Shared/SEO"));
const ProductLayout = dynamic(() => import("../../components/Layout/ProductLayout"));
const SmallBanner = dynamic(() => import("../../components/Shared/Banners/SmallBanner"));

const endpoint = "legal";

const LegalPage = props => {
	const { token } = props;

	const [pageDataRes, entriesDataRes] = useQueries({
		queries: [
			{
				queryKey: queryKeyManager(['legal'], [token]),
				queryFn: () => getQueryFn(`${endpoint}`, token),
				...queryConfig
			},
			{
				queryKey: queryKeyManager(['legal', 'entries'], [token]),
				queryFn: () => getQueryFn(`${endpoint}/list`, token),
				...queryConfig
			}
		],
	});

	if (pageDataRes.isLoading || entriesDataRes.isLoading) {
		return <span />
	}

	const pageData = pageDataRes.data;
	const articles = entriesDataRes.data;

	return (
		<Fragment>
			<SEO seo={pageData.seo} />
			<ProductLayout
				nav={pageData.nav.header.links} logo={pageData.nav.header.logos.general} footer={pageData.nav.footer}>
				<SmallBanner banner={pageData.banner} />
				{/* <SubHeader nav={getSubNav(category)} /> */}
				<div className="customContainer">
					{articles.data.map((article, i) => {
						return (
							<div className="row legalHolder" key={`article-${i}`}>
								<div className="col s12 m12 l8 featuredLegalCard">
									<div className="legalFeatured">
										<h2 className="title">
											{article.title}
										</h2>
										<div className="excerpt">
											{article.excerpt
												? parse(article.excerpt)
												: ""}
										</div>
										<a
											className="readMore"
											href={article.url}
											title="Read More"
										>
											Read More
										</a>
									</div>
								</div>
							</div>
						);
					})}
				</div>
			</ProductLayout>
		</Fragment>
	);
};

LegalPage.getInitialProps = async ({ query, req }) => {
	const queryClient = new QueryClient();
	const { token } = query;
	await queryClient.prefetchQuery({
		queryKey: queryKeyManager(['legal'], [token]),
		queryFn: () => getQueryFn(`${endpoint}`, token),
		...queryConfig
	});
	await queryClient.prefetchQuery({
		queryKey: queryKeyManager(['legal', 'entries'], [token]),
		queryFn: () => getQueryFn(`${endpoint}/list`, token),
		...queryConfig
	});
	return {
		token: token,
		dehydratedState: dehydrate(queryClient)
	};
};

export default LegalPage;